import { apiFetch } from '../utils/apiFetch';  // Add at the top

const apiUrl = process.env.REACT_APP_API_URL;

export async function fetchChallengesDetails() {
  try {
    const response = await apiFetch(`${apiUrl}/challenges`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(response.status === 403
        ? 'You do not have permission to view challenges.'
        : 'Failed to fetch challenges.');
    }

    const data = await response.json();
    return data.map((challenge) => ({
      ...challenge,
      name: encodeURIComponent(challenge.name),
    }));
  } catch (error) {
    console.error('Error fetching challenges:', error.message);
    throw error;
  }
}

export async function createChallenge(challenge) {
  const response = await apiFetch(`${apiUrl}/challenges`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(challenge),
  });

  if (!response.ok) {
    throw new Error(response.status === 403
      ? 'You do not have permission to create challenges.'
      : 'Failed to create challenge.');
  }

  return await response.json();
}

export async function updateChallenge(challengeId, updatedChallenge) {
  const response = await apiFetch(`${apiUrl}/challenges/${challengeId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedChallenge),
  });

  if (!response.ok) {
    throw new Error(response.status === 403
      ? 'You do not have permission to update challenges.'
      : 'Failed to update challenge.');
  }

  return await response.json();
}

export async function deleteChallenge(challengeId) {
  const response = await apiFetch(`${apiUrl}/challenges/${challengeId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    throw new Error(response.status === 403
      ? 'You do not have permission to delete challenges.'
      : 'Failed to delete challenge.');
  }

  return { message: 'Challenge deleted successfully.' };
}


export async function getReviewsByChallengeId(challengeId) {
  try {
    const response = await apiFetch(`${apiUrl}/challenges/${challengeId}/reviews`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch reviews for challenge ${challengeId}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching challenge reviews:', error);
    throw error;
  }
}

export async function getChallengeById(id) {
  const response = await apiFetch(`${apiUrl}/challenges/${id}`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch challenge with ID ${id}`);
  }

  return await response.json();
}

export async function getAllTags() {
  console.log('Fetching all tags...: No fetch functionality implemented yet');
  /*try {
    const response = await apiFetch(`${apiUrl}/tags/`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch tags');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching tags:', error);
    throw error;
  }*/
}